import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header, Table, Label, Icon, Pagination, Dropdown } from 'react-frontier';
import { useBreadcrumbs } from '../Hooks';
import { PromoterActivity, PromoterActivityType, UserClass } from '../SiteClasses';
import { formatUnix, activityStatus } from '../SiteUtil';
import API from '../API';

const PAGE_SIZE = 20;

var ActivitiesMaster = ()=>{
	var navigate = useNavigate();
	var { setTitle } = useBreadcrumbs();
	var [loadError, setLoadError] = useState<string>(null);
	var [activities, setActivities] = useState<PromoterActivity[]>(null);
	var [total, setTotal] = useState<number>(0);
	var [page, setPage] = useState<number>(0);
	var [users, setUsers] = useState<UserClass[]>(null);
	var [types, setTypes] = useState<PromoterActivityType[]>(null);
	var [userFilter, setUserFilter] = useState<number>(null);
	var [typeFilter, setTypeFilter] = useState<number>(null);
	var [statusFilter, setStatusFilter] = useState<'completed' | 'pending' | 'overdue'>(null);

	useEffect(()=>{
		setTitle('Actividades');
		API.getUsers(200, 0).then(res=>{ if(!res.error) setUsers(res.data || []); }).catch(()=>{});
		API.getActivityTypes().then(res=>{ if(!res.error) setTypes(res.data || []); }).catch(()=>{});
	}, []);

	useEffect(()=>{
		setActivities(null);
		setLoadError(null);
		API.getAllActivities({
			user_id: userFilter ?? undefined,
			activity_type_id: typeFilter ?? undefined,
			status: statusFilter ?? undefined,
			page,
		}).then(res=>{
			if(res.error) return setLoadError(res.message);
			setActivities(res.data.activities);
			setTotal(res.data.total);
		}).catch(()=>{
			setLoadError('Hubo un error al obtener las actividades. (GAC-1)');
		});
	}, [userFilter, typeFilter, statusFilter, page]);

	if(loadError) return <Header text='Error' subtext={loadError} />;

	return <div>
		<Table style={{ maxWidth: 1000, margin: 'auto', marginTop: 20 }} striped selectable>
			<Table.Head title='Actividades'>
				<Table.Row>
					<Table.Cell colSpan={8} style={{ padding: 8 }}>
						<div style={{ display: 'flex', gap: 8 }}>
							<Dropdown
								search
								label='Usuario'
								placeholder='Usuario'
								value={userFilter!=null ? String(userFilter) : ''}
								items={[{ text: 'Todos', value: '' }, ...(users || []).map(u=>({ text: `${u.first_name} ${u.last_name}`, value: String(u.user_id) }))]}
								onValueChange={v=>{ setUserFilter(v!=null && v!=='' ? parseInt(v) : null); setPage(0); }}
								style={{ minWidth: 200, margin: 0, flex: 1 }}
							/>
							<Dropdown
								search
								label='Tipo de actividad'
								placeholder='Tipo'
								value={typeFilter!=null ? String(typeFilter) : ''}
								items={[{ text: 'Todos', value: '' }, ...(types || []).map(t=>({ text: t.type_name, value: String(t.activity_type_id) }))]}
								onValueChange={v=>{ setTypeFilter(v!=null && v!=='' ? parseInt(v) : null); setPage(0); }}
								style={{ minWidth: 200, margin: 0, flex: 1 }}
							/>
							<Dropdown
								label='Estatus'
								placeholder='Estatus'
								value={statusFilter || ''}
								items={[{ text: 'Todos', value: '' }, { text: 'Completada', value: 'completed' }, { text: 'Pendiente', value: 'pending' }, { text: 'Retrasada', value: 'overdue' }]}
								onValueChange={v=>{ setStatusFilter(v==='completed' || v==='pending' || v==='overdue' ? v : null); setPage(0); }}
								style={{ minWidth: 160, margin: 0 }}
							/>
						</div>
					</Table.Cell>
				</Table.Row>
				<Table.Row>
					<Table.Cell header collapsing>Tipo</Table.Cell>
					<Table.Cell header>Título</Table.Cell>
					<Table.Cell header collapsing>Creador</Table.Cell>
					<Table.Cell header collapsing>Promotor</Table.Cell>
					<Table.Cell header collapsing centered>Estado</Table.Cell>
					<Table.Cell header collapsing>Fecha actividad</Table.Cell>
					<Table.Cell header collapsing>Creación</Table.Cell>
					<Table.Cell header collapsing>Completada</Table.Cell>
				</Table.Row>
			</Table.Head>
			<Table.Body>
				{!activities ? (
					<Table.Row><Table.Cell colSpan={8} centered><Header loading text='Cargando datos' /></Table.Cell></Table.Row>
				) : activities.length === 0 ? (
					<Table.Row><Table.Cell colSpan={8} centered>No se encontraron actividades</Table.Cell></Table.Row>
				) : (
					activities.map(a=>{
						var to = a.prospect_id ? `/prospects/${a.prospect_id}` : `/promoters/${a.promoter_id}`;
						return <Table.Row key={a.activity_id} selectable onClick={()=>navigate(to)}>
							<Table.Cell collapsing>{a.type_name}</Table.Cell>
							<Table.Cell>{a.title}</Table.Cell>
							<Table.Cell collapsing>{a.user_creator_name || <Icon name='minus' />}</Table.Cell>
							<Table.Cell collapsing>{a.target_name || <Icon name='minus' />}</Table.Cell>
							<Table.Cell collapsing centered>
								{(()=>{ var st = activityStatus(a); return <Label color={st.color} size='small'>{st.text}</Label>; })()}
							</Table.Cell>
							<Table.Cell collapsing>{formatUnix(a.date_activity, 'dd/MMM/yyyy HH:mm')}</Table.Cell>
							<Table.Cell collapsing>{a.date_created ? formatUnix(a.date_created, 'dd/MMM/yyyy HH:mm') : <Icon name='minus' />}</Table.Cell>
							<Table.Cell collapsing>{a.completed && a.date_completed ? formatUnix(a.date_completed, 'dd/MMM/yyyy HH:mm') : <Icon name='minus' />}</Table.Cell>
						</Table.Row>;
					})
				)}
			</Table.Body>
		</Table>
		{(total > PAGE_SIZE || page !== 0) && (
			<div style={{ maxWidth: 1000, margin: 'auto', marginTop: 10 }}>
				<Pagination page={page} pageCount={Math.ceil(total / PAGE_SIZE)} onPageChange={setPage} />
			</div>
		)}
	</div>;
}

export default ActivitiesMaster;
